module.exports = __webpack_public_path__ + "img/achal_yes.03e4bc54.png";